import React, { Fragment } from 'react'
import Img1 from "../images/signature-deal-4.png"
import Img2 from "../images/signature-deal-1.png"
import Img3 from "../images/signature-deal-2.png"
import Img4 from "../images/signature-deal-3.png"
import Img5 from "../images/crocodile.png"
import Img6 from "../images/favorites-deal-1.jpg"
import Img7 from "../images/favorites-deal-2.jpg"
import Img8 from "../images/favorites-deal-3.jpg"
import Img9 from "../images/favorites-deal-4.jpg"
import Img10 from "../images/favorites-deal-5.jpg"
import Img11 from "../images/addons-6.png"
import Img12 from "../images/addons-5.png"
import Img13 from "../images/addons-1.png"
import Img14 from "../images/addons-2.png"
import Img15 from "../images/addons-4.png"
import Img16 from "../images/addons-3.png"
import { Link } from 'react-router-dom'

const MenuOne = () => {
    return (
        <Fragment>
            <section className="p-[5vmax_3vmax]">
                <div className="flex-center flex-col ">
                    <h3 className='text-[1.8vmax]  font-2 text-green-600' >Signature Plates</h3>
                    <h2 className='text-[5vmax] text-center font-[900] text-[#222]' >Bold Cajun Flavors</h2>

                    <div className="flex justify-between">
                        <div className="w-[20%] relative">
                            <div className="absolute top-[5vmax] left-0 w-[120%] animate-bounce">

                                <img src={Img5} alt="" className='w-[100%]' />
                            </div>
                        </div>
                        <div className="grid grid-cols-[1fr_1fr_1fr_1fr] gap-[2vmax] w-[80%] mt-[5vmax]">
                            <div className="customBG p-[1.5vmax] rounded-xl flex-center flex-col gap-[1vmax] hover:translate-y-[-1.5vmax] group pb-[0] ">
                                <h3 className='text-[1.8vmax] font-extrabold text-[#222] text-center' >Fried <br /> Chicken</h3>

                                <div className='py-[0.5vmax] font-extrabold text-green-600 text-[2vmax]' >$ 29.99</div>
                                <button className=' text-green-600 shadow-1 p-[0.5vmax_2vmax] rounded-full font-bold text-[1vmax]  hover:text-white hover:bg-green-600' >
                                    <i class="fa-solid fa-cart-shopping text-[0.9vmax]"></i> &nbsp;&nbsp;Order Now
                                </button>
                                <img src={Img1} alt="" className='w-[90%] group-hover:translate-y-[-1.5vmax]' />
                            </div>
                            <div className="customBG p-[1.5vmax] rounded-xl flex-center flex-col gap-[1vmax] hover:translate-y-[-1.5vmax] group pb-[0]">
                                <h3 className='text-[1.8vmax] font-extrabold text-[#222] text-center text-center' >
                                    Shrimp & Catfish Combo Basket
                                </h3>

                                <div className='py-[0.5vmax] font-extrabold text-green-600 text-[2vmax]' >$ 26.99</div>
                                <button className=' text-green-600 shadow-1 p-[0.5vmax_2vmax] rounded-full font-bold text-[1vmax]  hover:text-white hover:bg-green-600' >
                                    <i class="fa-solid fa-cart-shopping text-[0.9vmax]"></i> &nbsp;&nbsp;Order Now
                                </button>
                                <img src={Img2} alt="" className='w-[90%] group-hover:translate-y-[-1.5vmax]' />
                            </div>
                            <div className="customBG p-[1.5vmax] rounded-xl flex-center flex-col gap-[1vmax] hover:translate-y-[-1.5vmax] group pb-[0]">
                                <h3 className='text-[1.8vmax] font-extrabold text-[#222] text-center' >Smoked <br />Oxtail</h3>

                                <div className='py-[0.5vmax] font-extrabold text-green-600 text-[2vmax]' >$ 38.99</div>
                                <button className=' text-green-600 shadow-1 p-[0.5vmax_2vmax] rounded-full font-bold text-[1vmax]  hover:text-white hover:bg-green-600' >
                                    <i class="fa-solid fa-cart-shopping text-[0.9vmax]"></i> &nbsp;&nbsp;Order Now
                                </button>
                                <img src={Img3} alt="" className='w-[90%] group-hover:translate-y-[-1.5vmax]' />
                            </div>
                            <div className="customBG p-[1.5vmax] rounded-xl flex-center flex-col gap-[1vmax] hover:translate-y-[-1.5vmax] group pb-[0]">
                                <h3 className='text-[1.8vmax] font-extrabold text-[#222] text-center' >Smoked Jerk Chicken Plate</h3>

                                <div className='py-[0.5vmax] font-extrabold text-green-600 text-[2vmax]' >$ 25.99</div>
                                <button className=' text-green-600 shadow-1 p-[0.5vmax_2vmax] rounded-full font-bold text-[1vmax]  hover:text-white hover:bg-green-600' >
                                    <i class="fa-solid fa-cart-shopping text-[0.9vmax]"></i> &nbsp;&nbsp;Order Now
                                </button>
                                <img src={Img4} alt="" className='w-[90%] group-hover:translate-y-[-1.5vmax]' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <section className="p-[5vmax_3vmax] customBG-2">
                <div className="flex-center flex-col ">
                    <h3 className='text-[1.8vmax]  font-2 text-green-600' >Favorites</h3>
                    <h2 className='text-[5vmax] text-center font-[900] text-white' >Customer Top Picks</h2>
                    <div className="grid grid-cols-[1fr_1fr] gap-[3vmax_5vmax] mt-[5vmax]  justify-center items-center">
                        <div className="grid grid-cols-[0.8fr_3fr] gap-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-[1.5vmax]" >
                            <div className="w-full aspect-square overflow-hidden rounded-xl">
                                <img src={Img6} alt="" />
                            </div>
                            <div className="relative">
                                <h3 className='text-[1.8vmax] font-extrabold text-green-500 mb-[1vmax] ' >
                                    Flavor Loaded Wings (10)
                                </h3>
                                <p className='text-white font-[400]' >
                                    Choose from bold flavors like Buffalo, Honey Lemon Pepper, or Korean BBQ.
                                    Also available in Garlic Parmesan, Sweet Asian, or Caribbean Jerk styles.
                                </p>
                                <div className="absolute top-[0vmax] right-[0vmax]   flex-center rounded-full bg-white
                             p-[0.3vmax_1vmax] font-extrabold text-black text-[1.3vmax]">
                                    $ 21.99
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.8fr_3fr] gap-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-[1.5vmax]">
                            <div className="w-full aspect-square overflow-hidden rounded-xl">
                                <img src={Img7} alt="" />
                            </div>
                            <div className="relative">
                                <h3 className='text-[1.8vmax] font-extrabold text-green-500 mb-[1vmax] ' >
                                    Creamy Cajun Delight
                                </h3>
                                <p className='text-white font-[400]' >
                                    Pasta tossed with bell peppers, andouille sausage, and Cajun cream sauce.
                                    Choose your protein: chicken, shrimp, salmon, lamb chop, or oxtail.
                                </p>
                                <div className="absolute top-[0vmax] right-[0vmax]   flex-center rounded-full bg-white
                             p-[0.3vmax_1vmax] font-extrabold text-black text-[1.3vmax]">
                                    $ 23.99
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.8fr_3fr] gap-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-[1.5vmax]">
                            <div className="w-full aspect-square overflow-hidden rounded-xl">
                                <img src={Img8} alt="" />
                            </div>
                            <div className="relative">
                                <h3 className='text-[1.8vmax] font-extrabold text-green-500 mb-[1vmax] ' >
                                    Steak Truffle Fries
                                </h3>
                                <p className='text-white font-[400]' >
                                    Crispy fries topped with steak, truffle flavor, and garlic aioli drizzle.
                                    Finished with parmesan cheese and rich au poivre sauce.
                                </p>
                                <div className="absolute top-[0vmax] right-[0vmax]   flex-center rounded-full bg-white
                             p-[0.3vmax_1vmax] font-extrabold text-black text-[1.3vmax]">
                                    $ 22.99
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.8fr_3fr] gap-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-[1.5vmax]">
                            <div className="w-full aspect-square overflow-hidden rounded-xl">
                                <img src={Img9} alt="" />
                            </div>
                            <div className="relative">
                                <h3 className='text-[1.8vmax] font-extrabold text-green-500 mb-[1vmax] ' >
                                    Steak or Chicken Quesadillas
                                </h3>
                                <p className='text-white font-[400]' >
                                    Grilled quesadillas filled with steak or chicken and melted cheese.
                                    Served with sour cream, salsa, and sautéed bell peppers.
                                </p>
                                <div className="absolute top-[0vmax] right-[0vmax]   flex-center rounded-full bg-white
                             p-[0.3vmax_1vmax] font-extrabold text-black text-[1.3vmax]">
                                    $ 18.99
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.8fr_3fr] gap-[1.5vmax] col-span-2 justify-self-center 
                            w-[calc(50%-2.5vmax)] rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-[1.5vmax]">
                            <div className="w-full aspect-square overflow-hidden rounded-xl">
                                <img src={Img10} alt="" />
                            </div>
                            <div className="relative">
                                <h3 className='text-[1.8vmax] font-extrabold text-green-500 mb-[1vmax] ' >
                                    Soft Flour Tacos (3)
                                </h3>
                                <p className='text-white font-[400]' >
                                    Soft tacos filled with chicken or beef, fresh lettuce, and tomatoes.
                                    Topped with cheese, sour cream, and a spicy Baja-style sauce.
                                </p>
                                <div className="absolute top-[0vmax] right-[0vmax]   flex-center rounded-full bg-white
                             p-[0.3vmax_1vmax] font-extrabold text-black text-[1.3vmax]">
                                    $ 19.99
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <section className="p-[5vmax_3vmax] customBG-3">
                <div className="flex-center flex-col ">
                    <h3 className='text-[1.8vmax]  font-2 text-green-600' >Add Ons</h3>
                    <h2 className='text-[5vmax] text-center font-[900] text-[#222]' >Extra Flavor Boost</h2>
                    <div className="grid grid-cols-[1fr_1fr] gap-[2vmax] w-[80%] mt-[5vmax]">
                        <div className="grid grid-cols-[0.9fr_1.5fr] gap-[1vmax] relative items-center p-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border-[0.3vmax] border-dashed border-green-500 shadow-2xl hover:translate-y-[-1vmax]">
                            <div className="aspect-square overflow-hidden rounded-">
                                <img src={Img11} alt="" className='w-full object-contain' />
                            </div>

                            <div className="">
                                <h3 className='text-[1.8vmax] font-extrabold  mb-[1vmax] ' >
                                    Extra Cheese
                                </h3>
                                <div className="w-fit rounded-full text-white
                             p-[0.3vmax_1vmax] font-extrabold bg-green-500 text-[1.3vmax] mb-[1vmax]">
                                    $ 2.99
                                </div>

                                <p className='text-black font-[400]  border-t-[0.2vmax] border-green-500 pt-[1vmax] border-dashed ' >
                                    Melted cheese added for extra richness and flavor.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.9fr_1.5fr] gap-[1vmax] relative items-center p-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border-[0.3vmax] border-dashed border-green-500 shadow-2xl hover:translate-y-[-1vmax]">
                            <div className="aspect-square overflow-hidden rounded-">
                                <img src={Img12} alt="" className='w-full object-contain' />
                            </div>

                            <div className="">
                                <h3 className='text-[1.8vmax] font-extrabold  mb-[1vmax] ' >
                                    Crispy Bacon
                                </h3>
                                <div className="w-fit rounded-full text-white
                             p-[0.3vmax_1vmax] font-extrabold bg-green-500 text-[1.3vmax] mb-[1vmax]">
                                    $ 3.99
                                </div>

                                <p className='text-black font-[400]  border-t-[0.2vmax] border-green-500 pt-[1vmax] border-dashed ' >
                                    Smoky, crispy bacon strips to enhance your meal.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.9fr_1.5fr] gap-[1vmax] relative items-center p-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border-[0.3vmax] border-dashed border-green-500 shadow-2xl hover:translate-y-[-1vmax]">
                            <div className="aspect-square overflow-hidden rounded-">
                                <img src={Img13} alt="" className='w-full object-contain' />
                            </div>

                            <div className="">
                                <h3 className='text-[1.8vmax] font-extrabold  mb-[1vmax] ' >
                                    Extra Shrimp
                                </h3>
                                <div className="w-fit rounded-full text-white
                             p-[0.3vmax_1vmax] font-extrabold bg-green-500 text-[1.3vmax] mb-[1vmax]">
                                    $ 5.99
                                </div>

                                <p className='text-black font-[400]  border-t-[0.2vmax] border-green-500 pt-[1vmax] border-dashed ' >
                                    Juicy fried shrimp added for a seafood boost.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.9fr_1.5fr] gap-[1vmax] relative items-center p-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border-[0.3vmax] border-dashed border-green-500 shadow-2xl hover:translate-y-[-1vmax]">
                            <div className="aspect-square overflow-hidden rounded-">
                                <img src={Img14} alt="" className='w-full object-contain' />
                            </div>

                            <div className="">
                                <h3 className='text-[1.8vmax] font-extrabold  mb-[1vmax] ' >
                                    Extra Chicken
                                </h3>
                                <div className="w-fit rounded-full text-white
                             p-[0.3vmax_1vmax] font-extrabold bg-green-500 text-[1.3vmax] mb-[1vmax]">
                                    $ 4.99
                                </div>

                                <p className='text-black font-[400]  border-t-[0.2vmax] border-green-500 pt-[1vmax] border-dashed ' >
                                    Tender chicken pieces for added protein and taste.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.9fr_1.5fr] gap-[1vmax] relative items-center p-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border-[0.3vmax] border-dashed border-green-500 shadow-2xl hover:translate-y-[-1vmax]">
                            <div className="aspect-square overflow-hidden rounded-">
                                <img src={Img15} alt="" className='w-full object-contain' />
                            </div>

                            <div className="">
                                <h3 className='text-[1.8vmax] font-extrabold  mb-[1vmax] ' >
                                    Garlic Bread
                                </h3>
                                <div className="w-fit rounded-full text-white
                             p-[0.3vmax_1vmax] font-extrabold bg-green-500 text-[1.3vmax] mb-[1vmax]">
                                    $ 3.99
                                </div>

                                <p className='text-black font-[400]  border-t-[0.2vmax] border-green-500 pt-[1vmax] border-dashed ' >

                                    Toasted garlic bread with butter and herbs, perfect for dipping.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-[0.9fr_1.5fr] gap-[1vmax] relative items-center p-[1.5vmax] rounded-2xl bg-white/10 backdrop-blur-xl border-[0.3vmax] border-dashed border-green-500 shadow-2xl hover:translate-y-[-1vmax]">
                            <div className="aspect-square overflow-hidden rounded-">
                                <img src={Img16} alt="" className='w-full object-contain' />
                            </div>

                            <div className="">
                                <h3 className='text-[1.8vmax] font-extrabold  mb-[1vmax] ' >
                                    Extra Sauce
                                </h3>
                                <div className="w-fit rounded-full text-white
                             p-[0.3vmax_1vmax] font-extrabold bg-green-500 text-[1.3vmax] mb-[1vmax]">
                                    $ 1.99
                                </div>

                                <p className='text-black font-[400]  border-t-[0.2vmax] border-green-500 pt-[1vmax] border-dashed ' >

                                    Extra sauce for added flavor and moisture.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <div className="fixed bottom-[2vmax] left-[50%] -translate-x-1/2 p-[0.5vmax_2vmax] rounded-full bg-green-600 shadow-1   hover:translate-y-[-1vmax]">
                <Link to={`/`} className='bg-green-600 text-white text-[1.5vmax] font-extrabold' >
                    Go Back
                </Link>
            </div>
        </Fragment>
    )
}

export default MenuOne
